import Vue from "vue";
import VueRouter from "vue-router";
import cookie from "vue-cookies";

var indexPage = cookie.get("indexPage");
var redirectUri = indexPage ? "/" + indexPage : "/login";

//去掉提示
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: redirectUri,
  },
  {
    path: "/",
    component: (resolve) => require(["../views/index.vue"], resolve),
    children: [
      {
        path: "/companyInfo",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业简介",
          p_name: "企业推介",
        },
      },
      {
        path: "/page1",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业简介",
          p_name: "企业推介",
        },
      },
      {
        path: "/page2",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业文化",
          p_name: "企业推介",
        },
      },
      {
        path: "/page3",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "发展规划",
          p_name: "企业推介",
        },
      },
      {
        path: "/page4",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "组织机构",
          p_name: "企业推介",
        },
      },
      {
        path: "/page5",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "人才队伍",
          p_name: "企业推介",
        },
      },
      {
        path: "/page6",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "主营业务",
          p_name: "企业推介",
        },
      },
      {
        path: "/page7",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "经营规模",
          p_name: "企业推介",
        },
      },
      {
        path: "/page8",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "科技创新",
          p_name: "企业推介",
        },
      },
      {
        path: "/page9",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业资质",
          p_name: "企业推介",
        },
      },
      {
        path: "/page10",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "核心产品",
          p_name: "企业推介",
        },
      },
      {
        path: "/page11",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "视频安防",
          p_name: "企业推介",
        },
      },
      {
        path: "/page12",
        component: (resolve) =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "获奖荣誉",
          p_name: "企业推介",
        },
      },
      {
        path: "/integratedDisplay",
        component: (resolve) =>
          require([
            "../views/safetyManagement/video/companyImgList.vue",
          ], resolve),
        meta: {
          title: "企业总览",
          p_name: "企业总览",
        },
      },
      {
        path: "/video3d", //
        component: (resolve) =>
          require(["../views/safetyManagement/video/video3d.vue"], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维",
        },
      },
      {
        path: "/zhuangbei3d", //
        component: (resolve) =>
          require(["../views/safetyManagement/video/zhuangbei3d.vue"], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维",
        },
      },
      {
        path: "/empty", //
        component: (resolve) =>
          require(["../views/safetyManagement/video/empty.vue"], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维",
        },
      },
      {
        path: "/nanjing3d",
        component: (resolve) =>
          require(["../views/safetyManagement/video/nanjing3d.vue"], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维",
        },
      },
      {
        path: "/videoMonitoring",
        component: (resolve) =>
          require(["../views/safetyManagement/videoMonitoring.vue"], resolve),
        meta: {
          title: "视频监控",
          p_name: "实时监控",
        },
      },
      {
        path: "/equipmentClassification",
        component: (resolve) =>
          require([
            "../views/equipmentManagement/equipmentClassification.vue",
          ], resolve),
        meta: {
          title: "设备分类",
          p_name: "设备管理",
        },
      },
      {
        path: "/nineBranchFactory",
        component: (resolve) =>
          require([
            "../views/safetyManagement/wisdomWorkshop/nineBranchFactory.vue",
          ], resolve),
        meta: {
          title: "",
          p_name: "九分厂",
        },
      },
      {
        path: "/equipmentList",
        component: (resolve) =>
          require(["../views/equipmentManagement/equipmentList.vue"], resolve),
        meta: {
          title: "设备列表",
          p_name: "设备管理",
        },
      },
    ],
  },

  {
    path: "/GISOverview",
    component: (resolve) =>
      require(["../views/safetyManagement/video/projectOverview.vue"], resolve),
  },
  {
    path: "/agreement",
    component: (resolve) => require(["../views/agreement.vue"], resolve),
  },
  {
    path: "/login",
    component: (resolve) => require(["../views/login.vue"], resolve),
  },
];
/*var redirectCon = null;
for(let i = 0;i< routes.length;i++){
  let tempData = routes[i];
  if(!tempData.children){
    //全屏页面
    let firstLevel = tempData.path;
    if(firstLevel == redirectUri){
      redirectCon = tempData.component
    }
  }else{
    //有左侧菜单的页面
    let childrenPageArr = tempData.children;
    for(let i in childrenPageArr){
      let childPage = childrenPageArr[i];
      let childPagePath = childPage.path;
      if(childPagePath == redirectUri){
        redirectCon = childPage.component
      }
    }
  }
}*/
routes.push({
  path: "*",
  redirect: redirectUri,
});

const router = new VueRouter({
  routes,
});

export default router;
